export const NAVBAR_REFRESH_EXPANDED_WIDTH_CLASS = 'w-[190px]';
export const NAVBAR_REFRESH_EXPANDED_MARGIN_CLASS = 'md:ml-[190px]';
export const NAVBAR_REFRESH_COLLAPSED_WIDTH_CLASS = 'w-[60px]';
export const NAVBAR_REFRESH_COLLAPSED_MARGIN_CLASS = 'md:ml-[60px]';
